<div class="element-wrapper" [ngStyle]="wrapperStyles">
  @if (labelEnabled) {
    <blaze-element-header
      [color]="props?.style?.label?.color?.color1"
      [fontFamily]="props?.style?.titleBlock?.fontFamily"
      [fontSize]="props?.style?.titleBlock?.fontSize"
      [fontStyle]="props?.style?.titleBlock?.fontStyle"
      [fontWeight]="props?.style?.titleBlock?.fontWeight"
      [horizontalAlign]="props?.content?.title?.align"
      [icon]="props?.content?.title?.icon"
      [iconColor]="props?.content?.title?.iconColor?.color1"
      [iconPosition]="props?.content?.title?.iconPosition"
      [iconSize]="props?.style?.titleBlock?.iconSize"
      class="mb-16"
    >
      {{ label }}
    </blaze-element-header>
  }
  <div class="card-template" [class.clickable]="clickAction()" (click)="onCardClick($event)">
    <blaze-custom-template-renderer
      class="template"
      [code]="(templateCode$ | async) ?? ''"
      [context]="context$ | async"
    />
  </div>
</div>
